//createTourament.jsx
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import conversion from "../../assets/wito.png";
import backImage from "../../assets/fondo.png";
import CircleTorunamentAvatar from "../../utils/tournament/tournament_profile_img";
import FieldIcon from "../../utils/Register/field_icon";
import SendBtn from "../../utils/Register/send_btn";
import MenuField from "../../utils/Register/menu_field";
import HeadquartersPopUp from "../../utils/tournament/headquartes";
import PartnerPopUp from "../../utils/tournament/partners";
import { jwtDecode } from "jwt-decode";
import Select from "react-select";
import RulesPopup from "../../utils/tournament/rules";
import CategoryPopup from "../../utils/tournament/categoryPopup";
import { showToast } from "../../components/ToastNotification";
import { useNavigate } from "react-router-dom";

const OrganizationProfile = () => {
  const [tournamentName, setTournamentName] = useState("");
  const [edition, setEdition] = useState("");
  const [error, setError] = useState("");
  const [time, setTime] = useState("");
  const [price, setPrice] = useState("");
  const [showSedePopUp, setShowSedePopUp] = useState(false);
  const [selectedOptionInfanto, setSelectedOptionInfanto] = useState("");
  const [showCategoryPopup, setShowCategoryPopup] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedOptionSede, setSelectedOptionSede] = useState({ value: "" });
  const [location, setLocation] = useState({ lat: -0.94752, lng: -80.72245 });
  const token = useSelector((state) => state.user.token);
  const [image, setImage] = useState(null);
  const [userId, setUserId] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [sedes, setSedes] = useState([]);
  const [city, setCity] = useState("");
  const [tournamentType, setTournamentType] = useState("");
  const [partners, setPartners] = useState([]);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [showPartnerPopUp, setShowPartnerPopUp] = useState(false);
  const [rules, setRules] = useState("");
  const [showRulesPopup, setShowRulesPopup] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [selectedMatchType, setSelectedMatchType] = useState(null);

  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [showSubcategoryPopup, setShowSubcategoryPopup] = useState(false);

  const navigate = useNavigate();

  const handleSaveRules = (newRules) => {
    setRules(newRules);
  };

  const format = [
    { label: "Liga", value: "liga" },
    { label: "Fase de grupo", value: "Fase_de_grupo" },
  ];
  const optionsEnf = [
    { label: "Solo ida", value: "Solo_ida" },
    { label: "Ida - vuelta", value: "Ida_vuelta" },
  ];
  const optionsInf = [
    { label: "Sí", value: "Sí" },
    { label: "No", value: "No" },
  ];
  const OptionsSede = [{ label: "Crear Sede", value: "Crear Sede" }];
  const OptionsPartner = [
    { label: "Crear Patrocinador", value: "Crear Patrocinador" },
  ];

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
    }
  }, [token]);

  useEffect(() => {
    const fetchPartners = async () => {
      if (!token) return;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/partners`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok)
          throw new Error("Error al obtener los patrocinadores.");

        const data = await response.json();
        setPartners(
          data.map((partner) => ({ label: partner.name, value: partner.id })),
        );
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchPartners();
  }, [token]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  const handleAddPartner = (newPartner) => {
    setPartners((prev) => [
      ...prev,
      { label: newPartner.name, value: newPartner.id },
    ]);
    setSelectedPartners((prev) => [
      ...prev,
      { label: newPartner.name, value: newPartner.id },
    ]);
  };

  useEffect(() => {
    if (!token) {
      return;
    }

    const fetchSedes = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/sedes`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error("Error al obtener las sedes.");
        }

        const data = await response.json();
        setSedes(data);
      } catch (error) {
        setError("Error al cargar las sedes: " + error.message);
      }
    };

    fetchSedes();
  }, [token]);

  useEffect(() => {
    if (!token) {
      return;
    }

    const fetchOrganizations = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/organizations/`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error("Error al obtener las organizaciones.");
        }

        const data = await response.json();
        setOrganizations(data);

        if (data.length === 1) {
          setSelectedOrganization(data[0].id);
        }
      } catch (error) {
        setError("Error al cargar las organizaciones: " + error.message);
      }
    };

    fetchOrganizations();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tournamentName) {
      showToast.error("Por favor, ingrese el nombre del torneo");
      return;
    }
    if (!city) {
      showToast.error("Por favor, ingrese la ciudad del torneo");
      return;
    }

    const formData = new FormData();
    formData.append("organization_id", selectedOrganization);
    formData.append("tournament_name", tournamentName);
    formData.append("edition", edition);
    formData.append("tournament_type", tournamentType);
    if (selectedFormat && selectedFormat.value) {
      formData.append("format", selectedFormat.value);
    }
    if (selectedMatchType && selectedMatchType.value) {
      formData.append("match_type", selectedMatchType.value);
    }
    formData.append("city", city);
    formData.append("rules", rules);
    formData.append("match_time", time);
    formData.append("registration_fee", price);
    formData.append("sede_id", selectedOptionSede.value);
    formData.append("user_id", userId);

    let subcategoriesToSend = selectedSubcategories;
    if (!selectedSubcategories || selectedSubcategories.length === 0) {
      subcategoriesToSend = [
        {
          number: 0,
          group_name: "principal",
        },
      ];
    }

    formData.append("subcategories", JSON.stringify(subcategoriesToSend));

    // Agregar cada partner como un valor separado
    selectedPartners.forEach((partner) => {
      formData.append("partners[]", partner.value);
    });

    if (image) {
      formData.append("tournament_image", image);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/tournaments`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        },
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Error al crear el torneo.");
      }

      navigate("/my-tournaments");
      showToast.success("Torneo creado con éxito!");
    } catch (error) {
      setError(error.message);
      showToast.error(error.message);
      console.error("Error al crear el torneo:", error.message);
    }
  };
  return (
    <div className="flex items-center justify-center min-h-screen my-8">
      <div
        className="flex flex-col items-center bg-cover bg-center rounded-xl"
        style={{
          backgroundImage: `url(${backImage})`,
          maxWidth: "420px",
          padding: "0 5%",
          backgroundClip: "padding-box",
        }}
      >
        <div className="text-center text-white mb-8 mt-12">
          <h1 className="text-5xl font-bold">Es hora</h1>
          <p className="text-lg mt-2">De un nuevo torneo</p>
          <div className="flex justify-center mt-2">
            <img src={conversion} alt="Conversión" className="h-8" />
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-lg w-96">
          <div className="">
            {organizations.length === 0 ? (
              <div className="text-center">
                <p className="text-lg font-semibold mb-4">
                  No tienes organizaciones registradas.
                </p>
                <button
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
                  onClick={() => navigate("/orgnization-profile")}
                >
                  Crear Organización
                </button>
              </div>
            ) : organizations.length === 1 ? (
              <h2 className="text-2xl font-bold text-center mb-6">
                {organizations[0].name}
              </h2>
            ) : (
              <select
                className="w-full p-2 border rounded-lg"
                value={selectedOrganization}
                onChange={(e) => setSelectedOrganization(e.target.value)}
              >
                <option value="">Selecciona una organización</option>
                {organizations.map((org) => (
                  <option key={org.id} value={org.id}>
                    {org.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          <form onSubmit={handleSubmit}>
            <div className="flex justify-center mt-4">
              <CircleTorunamentAvatar
                size={100}
                onImageSelect={(e) => {
                  const file = e.target.files[0];
                  if (file) {
                    setImage(file);
                  }
                }}
              />
            </div>
            <FieldIcon
              id="orgnizationName"
              name="orgnizationName"
              type="text"
              autoComplete="on"
              placeholder="Nombre del torneo"
              value={tournamentName}
              required
              label="Nombre del torneo *"
              onChange={(e) => setTournamentName(e.target.value)}
            />
            <FieldIcon
              id="city"
              name="city"
              type="text"
              autoComplete="on"
              placeholder="Ciudad"
              value={city}
              required
              label="Ciudad *"
              onChange={(e) => setCity(e.target.value)}
            />
            <FieldIcon
              id="edition"
              name="edition"
              type="number"
              autoComplete="on"
              placeholder="Edición del torneo"
              value={edition}
              label="Edición del torneo"
              onChange={(e) => setEdition(e.target.value)}
            />
            <FieldIcon
              id="tournamentType"
              name="tournamentType"
              type="text"
              autoComplete="on"
              placeholder="Futbol 11"
              value={tournamentType}
              label="Tipo de torneo"
              onChange={(e) => setTournamentType(e.target.value)}
            />
            <div>
              <label className="block text-sm font-medium mb-2">
                Subcategorías
              </label>
              <button
                type="button"
                className="bg-blue-500 text-white px-3 py-1 rounded-lg mb-2"
                onClick={() => setShowSubcategoryPopup(true)}
              >
                Configurar Subcategorías
              </button>

              {showSubcategoryPopup && (
                <CategoryPopup
                  onClose={() => setShowSubcategoryPopup(false)}
                  onSave={(subs) => {
                    setSelectedSubcategories(subs);
                    setShowSubcategoryPopup(false);
                  }}
                  initialSubcategories={selectedSubcategories}
                />
              )}

              {selectedSubcategories.length > 0 && (
                <p className="mt-2 text-gray-700">
                  Subcategorías seleccionadas:{" "}
                  {selectedSubcategories
                    .map((sub) =>
                      sub.number && sub.group_name
                        ? `${sub.number} ${sub.group_name}`
                        : sub.number
                          ? sub.number
                          : sub.group_name,
                    )
                    .join(", ")}
                </p>
              )}
            </div>

            {/* Formato - Ahora opcional */}
            <label className="block text-sm font-medium mb-2">
              Formato (Opcional)
            </label>
            <Select
              options={format}
              value={selectedFormat}
              onChange={setSelectedFormat}
              placeholder="Selecciona un formato (opcional)"
              isClearable={true}
              className="mb-4"
            />

            {/* Tipo de partido - Ahora opcional */}
            <label className="block text-sm font-medium mb-2">
              Tipo de partido (Opcional)
            </label>
            <Select
              options={optionsEnf}
              value={selectedMatchType}
              onChange={setSelectedMatchType}
              placeholder="Selecciona un tipo de partido (opcional)"
              isClearable={true}
              className="mb-4"
            />

            <MenuField
              label="Sede"
              placeholder="Selecciona una opción"
              options={[
                ...OptionsSede,
                ...(Array.isArray(sedes)
                  ? sedes.map((sede) => ({
                      label: sede.label || sede.name,
                      value: sede.value || sede.id,
                    }))
                  : []),
              ]}
              selectedOption={selectedOptionSede.label}
              onOptionSelect={(option) => {
                if (option === "Crear Sede") {
                  setShowSedePopUp(true);
                } else {
                  const selectedSede = sedes.find(
                    (sede) => sede.label === option || sede.name === option,
                  );
                  if (selectedSede) {
                    setSelectedOptionSede({
                      label: selectedSede.label || selectedSede.name,
                      value: selectedSede.value || selectedSede.id,
                    });
                  }
                }
              }}
            />

            {showSedePopUp && (
              <HeadquartersPopUp
                onClose={() => setShowSedePopUp(false)}
                onSedeCreated={(newSede) => {
                  setSedes((prevSedes) => [...prevSedes, newSede]);
                  setSelectedOptionSede(newSede);
                  setShowSedePopUp(false);
                }}
              />
            )}

            <div>
              <label className="block text-sm font-medium mb-2">
                Reglamento
              </label>
              <div
                className="p-2 border rounded-lg cursor-pointer"
                onClick={() => setShowRulesPopup(true)}
              >
                {rules ? (
                  <div dangerouslySetInnerHTML={{ __html: rules }} />
                ) : (
                  <span className="text-gray-500">
                    Haz clic para editar el reglamento
                  </span>
                )}
              </div>

              {showRulesPopup && (
                <RulesPopup
                  onClose={() => setShowRulesPopup(false)}
                  onSave={handleSaveRules}
                />
              )}
            </div>
            <FieldIcon
              id="time"
              name="time"
              type="number"
              autoComplete="on"
              placeholder="60"
              value={time}
              label="Tiempo en minutos"
              onChange={(e) => setTime(e.target.value)}
            />
            <FieldIcon
              id="price"
              name="price"
              type="number"
              autoComplete="on"
              placeholder="10"
              value={price}
              label="Costo de inscripción"
              onChange={(e) => setPrice(e.target.value)}
            />
            <label className="block text-sm font-medium mb-2">
              Patrocinadores
            </label>
            <Select
              options={partners}
              isMulti
              value={selectedPartners}
              onChange={setSelectedPartners}
              placeholder="Selecciona patrocinadores"
              className="mb-4 "
            />
            <button
              type="button"
              className="text-blue-500 text-sm underline mb-4"
              onClick={() => setShowPartnerPopUp(true)}
            >
              Crear nuevo patrocinador
            </button>
            <SendBtn
              label="Guardar"
              type="submit"
              style={{ backgroundColor: "#E5960E" }}
            />
          </form>
        </div>
        {showPartnerPopUp && (
          <PartnerPopUp
            onClose={() => setShowPartnerPopUp(false)}
            onAddPartner={handleAddPartner}
          />
        )}
      </div>
    </div>
  );
};

export default OrganizationProfile;
